import React, { useState, useEffect, useCallback, useRef } from "react";
import Layout from "../../shared/Layout";
import { ActiveProductImageById, getCategoryData, getProductDataById, getProductImageByProductId, getProductSpecificationByProductId, getSubCategoryData, IsDisplayProductImageById, IsHeaderProductImageById, onDeleteProductImages, onDeleteProductSpecification, onSaveProductDetail, onSaveProductImages, onSaveProductSpecification, UploadImages } from "../../../_services";
import './productdetailbyid.css';
import SingleProductImages from "./SingleProductImages";
import SingleProductSpecification from "./SingleProductSpecification";
import { Link } from "react-router-dom";
import ReactQuill from 'react-quill'; import 'react-quill/dist/quill.snow.css';
import { resizeImage } from "../../../_services/resizeImage";
import ProductSku from "./ProductSku";
import { ToastContainer,toast } from "react-toastify";

// const baseUrl = process.env.REACT_APP_BASE_URL;

const ProductDetailById = () => {
    const pId = localStorage.getItem('SAproductId');
    const [imageSkuId, setImageSkuId] = useState(0);
    const [loading, setLoading] = useState(false);
    const [categoryData, setCategoryData] = useState([]);
    const [subCategoryData, setSubCategoryData] = useState([]);
    const [bulkPopupSkuId, setBulkPopupSkuId] = useState(false);

    const [isFormopen, setIsFormopen] = useState(false);
    const [productDetailByIdData, setProductDetailByIdData] = useState([]);
    const [productId, setProductId] = useState(null);

    const [isImageFormopen, setIsImageFormopen] = useState(false);
    const [productImageByProductId, setProductImageByProductId] = useState([]);
    const [productImageId, setProductImageId] = useState(null);

    const [isProductSpecificationFormopen, setIsProductSpecificationFormopen] = useState(false);
    const [productSpecificationByProductId, setProductSpecificationByProductId] = useState([]);
    const [productSpecificationId, setProductSpecificationId] = useState(null);

    const [activeSection, setActiveSection] = useState('productDetails');

    const fileInputRef = useRef(null);

    const [formData, setFormData] = useState({
        productId: 0,
        productCategoryId: null,
        productSubCategoryId: null,
        productName: '',
        displayName: '',
        shortDesc: '',
        displayDesc: '',
        salePrice: 0,
        mrp: 0,
        taxId: null,
        amazoneUrl: '',
        isDisplay: true,
        isActive: true,
        createdBy: 0
    });

    const [imageFormData, setImageFormData] = useState({
        productId: pId,
        imgPath: 'Image',
        file: '',
        isHeader: false,
        isDisplay: true,
        isActive: true
    });

    const [productSpecificationFormData, setProductSpecificationFormData] = useState({
        productId: pId,
        specificationId: 0,
        description: '',
        remark: '',
        isDisplay: true,
        isActive: true
    });

    const [bulkImageFormData, setBulkImageFormData] = useState({
        showOrder:0,
        files: [],
    });

    const onButtonToggle = (section) => {
        setActiveSection(section);
        setBulkPopupSkuId(false);
        setIsFormopen(false);
    };

    const fetchProductDetailById = async () => {
        try {
            const data = await getProductDataById();
            if (data !== null) {
                setProductDetailByIdData(data);
            }

        } catch (error) {
            setProductDetailByIdData([]);
        } finally {
            setLoading(false);
        }
    };

    const fetchCategoryData = async () => {
        try {
            const data = await getCategoryData();
            setCategoryData(data);
        } catch (error) {
            setCategoryData([]);
        } finally {
            setLoading(false);
        }
    };

    const fetchSubCategoryData = async () => {
        try {
            const data = await getSubCategoryData();
            setSubCategoryData(data);
        } catch (error) {
            setSubCategoryData([])
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;
        // setFormData(prevState => ({
        //     ...prevState,
        //     [name]: type === 'checkbox' ? checked : (type === 'file' ? files[0] : value)
        // }));

        if (type === 'file' && files[0]) {
            const file = files[0];

            if (file.type === 'image/jpeg' || file.type === 'image/png') {
                const image = new Image();
                image.src = URL.createObjectURL(file);

                image.onload = async () => {

                    try {
                        const resizedFile = await resizeImage(file);
                        setFormData((prevState) => ({
                            ...prevState,
                            [name]: resizedFile
                        }));
                    } catch (err) {
                        toast.error('Error resizing the image.');
                    }
                };
            } else {
                toast.error('Only JPEG and PNG images are allowed.');
            }
        } else {
            setFormData((prevState) => ({
                ...prevState,
                [name]: type === 'checkbox' ? checked : value
            }));
        }
    };

    // Handle the description input change
    const handleDescriptionChange = (value) => {
        setFormData(prev => ({
            ...prev,
            displayDesc: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        await onSaveProductDetail(formData);
        setLoading(false)
        fetchProductDetailById();
        setIsFormopen(false);
    };

    const handleReset = () => {
        setImageFormData({
            productId: '',
            imgPath: 'Image',
            file: null,
            isHeader: false,
            isDisplay: true,
            isActive: true
        });
    };

    const onEdit = (item) => {
        setProductId(item?.productId)
        setIsFormopen(true);
        setFormData({
            ...formData,
            productId: item.productId,
            productCategoryId: item?.productCategoryId,
            productSubCategoryId: item?.productSubCategoryId,
            productName: item?.productName,
            displayName: item?.displayName,
            shortDesc: item?.shortDesc,
            displayDesc: item?.displayDesc,
            salePrice: item?.salePrice,
            mrp: item?.mrp,
            taxId: item?.taxId,
            amazoneUrl: item?.amazoneUrl,
            isDisplay: item?.isDisplay,
            isActive: item?.isActive,
        })
    }

    // product images by productId
    const fetchProductImageByProductId = useCallback(async () => {
        try {
            const data = await getProductImageByProductId(pId);
            setProductImageByProductId(data);
        } catch (error) {
            setProductImageByProductId([]);
        } finally {
            setLoading(false);
        }
    }, [pId]);

    const onAddImage = () => {
        setBulkPopupSkuId(true);
    };

    const handleImageSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        try {
            await onSaveProductImages(imageFormData);
            fetchProductImageByProductId();
            setIsImageFormopen(false);
            onReset();
        } catch (error) {
            toast.error('Error submitting image:', error);
        } finally {
            setLoading(false);
        }
    };

    const onReset = () => {
        setImageFormData({
            productId: pId,
            imgPath: 'Image',
            file: null,
            isHeader: false,
            isDisplay: true,
            isActive: true
        });
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    }

    const productImageDelete = async (item) => {
        setLoading(true);
        try {
            await onDeleteProductImages(item);
            fetchProductImageByProductId();
        } catch (error) {
            toast.error('Error deleting image:', error);
        } finally {
            setLoading(false);
        }
    };

    // Product Specification By ProductId
    const fetchProductSpecificationByProductId = useCallback(async () => {
        try {
            const data = await getProductSpecificationByProductId(pId);
            setProductSpecificationByProductId(data);
        } catch (error) {
            setProductSpecificationByProductId([]);
        } finally {
            setLoading(false);
        }
    }, [pId]);

    const onAddProductSpecification = () => {
        setProductSpecificationId(0)
        setProductSpecificationFormData({
            productId: pId,
            specificationId: 0,
            description: '',
            remark: '',
            isDisplay: true,
            isActive: true
        });
        setIsProductSpecificationFormopen(true);
    };

    const handleProductSpecificationSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        try {
            await onSaveProductSpecification(productSpecificationFormData);
            fetchProductSpecificationByProductId();
            setIsProductSpecificationFormopen(false);
            setProductSpecificationId(0);
            setProductSpecificationFormData({
                productId: pId,
                specificationId: 0,
                description: '',
                remark: '',
                isDisplay: true,
                isActive: true
            });
        } catch (error) {
            toast.error('Error submitting image:', error);
        } finally {
            setLoading(false);
        }
    };

    const productProductSpecificationDelete = async (item) => {
        setLoading(true);
        try {
            await onDeleteProductSpecification(item);
            fetchProductSpecificationByProductId();
        } catch (error) {
            toast.error('Error deleting image:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCategoryData();
        fetchSubCategoryData();
        fetchProductDetailById();
        fetchProductImageByProductId();
        fetchProductSpecificationByProductId();
    }, [fetchProductImageByProductId, fetchProductSpecificationByProductId]);


    // product images sections functions
    const onBulkUpload = async (e) => {
        if (e) {
            e.preventDefault();
        }

        if (bulkImageFormData.files.length === 0) {
            toast.error("Please select at least one file to upload.");
            return;
        }

        const uploadData = new FormData();
        bulkImageFormData.files.forEach((file) => {
            uploadData.append("files", file);
        });

        try {
            const response = await UploadImages(uploadData, pId, imageSkuId);

            if (response?.isSuccess) {
                toast.success("Images uploaded successfully.");

                setBulkImageFormData({
                    showOrder:0,
                    files: [],
                });
                setImageSkuId(0);
                setBulkPopupSkuId(false);
                fetchProductImageByProductId();
                document.getElementById("file").value = "";
            }
        } catch (error) {
            toast.error("Failed to upload images. Please try again.");
        }
    };

    const isHeaderProductImageById = async (item) => {
        await IsHeaderProductImageById(item);
        fetchProductImageByProductId();
        toast.success("Update Successfully");
    };

    const isDisplayProductImageById = async (id) => {
        await IsDisplayProductImageById(id);
        fetchProductImageByProductId();
        toast.success("Update Successfully");
    };

    const isActiveProductImageById = async (id) => {
        await ActiveProductImageById(id);
        fetchProductImageByProductId();
        toast.success("Update Successfully");
    };

    const modules = {
        toolbar: [
            [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['bold', 'italic', 'underline'],
            [{ 'align': [] }],
            ['link'],
            ['image']
        ],
    };

    const bulkPopupClose = () => {
        setBulkImageFormData({
            files: [],
        });
        setBulkPopupSkuId(false);
    }

    return (
        <Layout>
           <ToastContainer
                autoClose={400}
                hideProgressBar={true}
                closeOnClick
                pauseOnHover
                draggable
                className='toaster'
            />
            <div className="px-4">
                <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading d-flex align-items-center" style={{ gap: "20px" }}>
                        <Link to='/productdetail'><svg
                            fill="none"
                            height="28"
                            viewBox="0 0 24 24"
                            width="28"
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                        >
                            <g width="100%" height="100%" transform="matrix(1,0,0,1,0,0)">
                                <path
                                    d="m19 1h-14c-2.2 0-4 1.8-4 4v14c0 2.2 1.8 4 4 4h14c2.2 0 4-1.8 4-4v-14c0-2.2-1.8-4-4-4zm-.5 12h-10.6l4.8 4.8c.4.4.4 1 0 1.4s-1 .4-1.4 0l-6.5-6.5c-.4-.4-.4-1 0-1.4l6.5-6.5c.4-.4 1.1-.4 1.4 0 .4.4.4 1 0 1.4l-4.8 4.8h10.6c.6 0 1 .4 1 1s-.4 1-1 1z"
                                    fill="#2a3653"
                                    fillOpacity="1"
                                />
                            </g>
                        </svg></Link>
                        <h4 className="mb-0">
                            {productDetailByIdData?.map((item, i) => (
                                <React.Fragment key={i}> {item?.productName}</React.Fragment>
                            ))}
                        </h4>
                    </div>
                </div>
                <div className="mt-3 d-flex justify-content-between">
                    <div className="optionbtn">
                        <button
                            className={activeSection === 'productDetails' ? 'active_button' : 'deactive_button'}
                            onClick={() => onButtonToggle('productDetails')}
                        >
                            Product Details
                        </button>
                        <button
                            className={activeSection === 'images' ? 'active_button' : 'deactive_button'}
                            onClick={() => onButtonToggle('images')}
                        >
                            Product Images
                        </button>
                        <button
                            className={activeSection === 'data' ? 'active_button' : 'deactive_button'}
                            onClick={() => onButtonToggle('data')}
                        >
                            Product Specification Data
                        </button>
                        <button
                            className={activeSection === 'productSku' ? 'active_button' : 'deactive_button'}
                            onClick={() => onButtonToggle('productSku')}
                        >
                            Product Sku
                        </button>
                    </div>
                    <div className="add_btn">
                        {/* {activeSection === 'images' && (
                            <button onClick={onAddImage}>
                                <img src={plus} alt="" />
                            </button>
                        )} */}
                        {/* {activeSection === 'data' && (
                            <button onClick={onAddProductSpecification}>
                                <img src={plus} alt="" />
                            </button>
                        )} */}
                    </div>
                </div>
                <div className="mb-4">
                    {activeSection === 'productDetails' && (
                        <div className="add_productimage mt-3">
                            <div className="product_details_box_main mt-4 d-flex">
                                <div className="product_detail_box px-4 py-3 col-8">
                                    {/* <div className="d-flex justify-content-end" style={{ gap: '8px' }}>
                                        <span title="Edit" onClick={() => productDetailByIdData && productDetailByIdData[0] ? onEdit(productDetailByIdData[0]) : null}>
                                            <svg clipRule="evenodd" fillRule="evenodd" strokeLinejoin="round" strokeMiterlimit="2" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" width="18" height="18" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" xmlnssvgjs="http://svgjs.dev/svgjs">
                                                <g transform="matrix(1,0,0,1,0,0)">
                                                    <g transform="translate(-2108 -328)">
                                                        <path d="M2144 328h-21c-3.98 0-7.79 1.58-10.61 4.393-2.81 2.813-4.39 6.629-4.39 10.607v34c0 3.978 1.58 7.794 4.39 10.607 2.82 2.813 6.63 4.393 10.61 4.393h26c3.98 0 7.79-1.58 10.61-4.393 2.81-2.813 4.39-6.629 4.39-10.607v-13c0-1.656-1.34-3-3-3s-3 1.344-3 3v13c0 2.387-.95 4.676-2.64 6.364-1.68 1.688-3.97 2.636-6.36 2.636-7.87 0-18.13 0-26 0-2.39 0-4.68-.948-6.36-2.636-1.69-1.688-2.64-3.977-2.64-6.364 0-9.956 0-24.044 0-34 0-2.387.95-4.676 2.64-6.364 1.68-1.688 3.97-2.636 6.36-2.636h21c1.66 0 3-1.344 3-3s-1.34-3-3-3zm9.12 2.636l-30.24 30.243c-.46.459-.76 1.054-.85 1.697l-2 14c-.13.935.18 1.878.85 2.545.67.668 1.61.982 2.54.849l14-2c.65-.092 1.24-.39 1.7-.849 0 0 19.21-19.212 30.24-30.242 1.69-1.688 2.64-3.977 2.64-6.364s-.95-4.676-2.64-6.364c-1.14-1.141-2.37-2.374-3.51-3.515-1.69-1.688-3.98-2.636-6.36-2.636-2.39 0-4.68.948-6.37 2.636zm-4.12 12.607 7.76 7.757-21.17 21.172s-9.05 1.292-9.05 1.292 1.29-9.05 1.29-9.05zm-.88 12.878 3-3c1.17-1.17 1.17-3.072 0-4.242-1.17-1.171-3.07-1.171-4.24 0l-3 3c-1.17 1.17-1.17 3.072 0 4.242 1.17 1.171 3.07 1.171 4.24 0zm12.88-9.364-7.76-7.757 4.12-4.121c.57-.563 1.33-.879 2.13-.879.79 0 1.55.316 2.12.879l3.51 3.514c.56.563.88 1.326.88 2.122 0 .795-.32 1.558-.88 2.121z"
                                                            fill="#526484ff" stroke="none"
                                                        />
                                                    </g>
                                                </g>
                                            </svg>
                                        </span>
                                    </div> */}
                                    <div className="row w-100 mt-2">
                                        <div className="product_content_all col-lg-6 row">
                                            <p className="product_heading_data col-lg-5">Category Name :</p>
                                            <p className="product_answer_data col-lg-7">{productDetailByIdData ? productDetailByIdData[0]?.categoryName : 'categoryName'}</p>
                                        </div>
                                        <div className="product_content_all col-lg-6 row">
                                            <p className="product_heading_data col-lg-5">SubCategory Name :</p>
                                            <p className="product_answer_data col-lg-7">{productDetailByIdData ? productDetailByIdData[0]?.productSubCategoryName : 'productSubCategoryName'}</p>
                                        </div>
                                        <div className="product_content_all col-lg-6 row">
                                            <p className="product_heading_data col-lg-5">Product Name :</p>
                                            <p className="product_answer_data col-lg-7">{productDetailByIdData ? productDetailByIdData[0]?.productName : null}</p>
                                        </div>
                                        <div className="product_content_all col-lg-6 row">
                                            <p className="product_heading_data col-lg-5">MRP :</p>
                                            <p className="product_answer_data col-lg-7">{productDetailByIdData ? productDetailByIdData[0]?.mrp : 0}</p>
                                        </div>
                                        <div className="product_content_all col-lg-6 row">
                                            <p className="product_heading_data col-lg-5">Sale Price :</p>
                                            <p className="product_answer_data col-lg-7">{productDetailByIdData ? productDetailByIdData[0]?.salePrice : 0}</p>
                                        </div>
                                        <div className="product_content_all col-lg-6 row">
                                            <p className="product_heading_data col-lg-5">Unit Price :</p>
                                            <p className="product_answer_data col-lg-7">{productDetailByIdData ? productDetailByIdData[0]?.unitPrice : 0}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {activeSection === 'images' && (
                        <div className="add_productimage mt-3">
                            <SingleProductImages
                                productImageByProductId={productImageByProductId}
                                isImageFormopen={isImageFormopen}
                                imageFormData={imageFormData}
                                setIsImageFormopen={setIsImageFormopen}
                                setImageFormData={setImageFormData}
                                pId={pId}
                                setLoading={setLoading}
                                handleImageSubmit={handleImageSubmit}
                                productImageDelete={productImageDelete}
                                productDetailByIdData={productDetailByIdData}
                                setProductImageId={setProductImageId}
                                productImageId={productImageId}
                                isHeaderProductImageById={isHeaderProductImageById}
                                isDisplayProductImageById={isDisplayProductImageById}
                                isActiveProductImageById={isActiveProductImageById}
                                fileInputRef={fileInputRef}
                                onReset={onReset}
                                bulkImageFormData={bulkImageFormData}
                                setBulkImageFormData={setBulkImageFormData}
                                onBulkUpload={onBulkUpload}
                                bulkPopupSkuId={bulkPopupSkuId}
                                setBulkPopupSkuId={setBulkPopupSkuId}
                                bulkPopupClose={bulkPopupClose}
                                onAddImage={onAddImage}
                            />
                        </div>
                    )}
                    {activeSection === 'data' && (
                        <div className="data mt-3 ">
                            <SingleProductSpecification
                                productDetailByIdData={productDetailByIdData}
                                loading={loading}
                                productSpecificationByProductId={productSpecificationByProductId}
                                pId={pId}
                                setIsProductSpecificationFormopen={setIsProductSpecificationFormopen}
                                isProductSpecificationFormopen={isProductSpecificationFormopen}
                                productSpecificationFormData={productSpecificationFormData}
                                setProductSpecificationFormData={setProductSpecificationFormData}
                                productSpecificationId={productSpecificationId}
                                setProductSpecificationId={setProductSpecificationId}
                                setLoading={setLoading}
                                handleProductSpecificationSubmit={handleProductSpecificationSubmit}
                                productProductSpecificationDelete={productProductSpecificationDelete}
                                fetchProductSpecificationByProductId={fetchProductSpecificationByProductId}
                                onAddProductSpecification={onAddProductSpecification}
                            />
                        </div>
                    )}
                    {activeSection === 'productSku' && (
                        <ProductSku
                            productId={pId}
                            bulkImageFormData={bulkImageFormData}
                            setBulkImageFormData={setBulkImageFormData}
                            setImageSkuId={setImageSkuId}
                            imageSkuId={imageSkuId}
                            onBulkUpload={onBulkUpload}
                            setBulkPopupSkuId={setBulkPopupSkuId}
                            bulkPopupSkuId={bulkPopupSkuId}
                            bulkPopupClose={bulkPopupClose}
                        />
                    )}
                </div>
            </div>

            <div id="entryformContainer" className={`adminform entryform ${isFormopen ? 'open' : ''}`}>
                <div className="closebtn">
                    <button className="" onClick={() => setIsFormopen(false)} >
                        <svg clipRule="evenodd" fillRule="evenodd" height="30" imageRendering="optimizeQuality" shapeRendering="geometricPrecision" textRendering="geometricPrecision" viewBox="0 0 6.82666 6.82666" width="30" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" >
                            <g transform="matrix(1,0,0,1,0,0)">
                                <g id="Layer_x0020_1">
                                    <rect fill="#ffffff00" height="6.827" rx="1.507" width="6.827" stroke="none" />
                                    <path d="m2.21002 1.41333-.79669.79669 1.20331 1.20331-1.20331 1.20331.79669.79669 1.20331-1.20331 1.20332 1.20331.79668-.79669-1.2033-1.20331 1.2033-1.20331-.79669-.79669-1.20331 1.2033z" fill="#fffffe" stroke="none" />
                                </g>
                            </g>
                        </svg>
                    </button>
                </div>
                <div className="enForm">
                    <div className="text-center form-heading">
                        <h4>Add Product Detail</h4>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="categorySelect">Product Category</label>
                            <select id="categorySelect" name="productCategoryId" className="form-control" value={formData.productCategoryId} onChange={handleChange} required>
                                <option value="">Select a category</option>
                                {categoryData?.map((category) => (
                                    <option key={category?.productCategoryId} value={category?.productCategoryId}>
                                        {category?.categoryName}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group">
                            <label htmlFor="categorySelect">Product Sub Category</label>
                            <select id="subcategorySelect" name="productSubCategoryId" className="form-control" value={formData.productSubCategoryId} onChange={handleChange} required>
                                <option value="">Select a sub category</option>
                                {subCategoryData.map((category) => (
                                    <option key={category?.productSubCategoryId} value={category?.productSubCategoryId}>
                                        {category?.productSubCategoryName}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group">
                            <label htmlFor="exampleFormControlInput1">Product Name</label>
                            <input type="text" className="form-control" id="productName" name="productName" placeholder="Product Name" value={formData.productName} onChange={handleChange} required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="exampleFormControlInput1">Display Name</label>
                            <input type="text" className="form-control" id="displayName" name="displayName" placeholder="Display Name" value={formData.displayName} onChange={handleChange} required />
                        </div>

                        <div className="form-group">
                            <label htmlFor="exampleFormControlInput1">Short Description{`(Max Limit: 200 Characters)`}</label>
                            <textarea type="text" className="form-control" id="shortDesc" name="shortDesc" placeholder="Short Description" value={formData.shortDesc} onChange={handleChange} required />
                        </div>

                        <div className="form-group">
                            <label htmlFor="exampleFormControlInput1">Display Description (Max : 600 Characters)</label>
                            <ReactQuill
                                value={formData.displayDesc}
                                onChange={handleDescriptionChange}
                                modules={modules}
                                theme="snow"
                                placeholder="Enter blog description here"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="exampleFormControlInput1">SalePrice</label>
                            <input type="text" className="form-control" id="salePrice" name="salePrice" placeholder="SalePrice" value={formData.salePrice} onChange={handleChange} required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="exampleFormControlInput1">Mrp</label>
                            <input type="text" className="form-control" id="mrp" name="mrp" placeholder="Mrp" value={formData.mrp} onChange={handleChange} required />
                        </div>
                        {/* <div className="form-group">
                            <label htmlFor="taxId">TaxId</label>
                            <select id="taxId" name="taxId" className="form-control" value={formData.taxId} onChange={handleChange} required>
                                <option value="">Select a TaxId</option>
                                {texType.map((textype) => (
                                    <option key={textype?.taxId} value={textype?.taxId}>
                                        {textype?.taxDisplay}
                                    </option>
                                ))}
                            </select>
                        </div> */}

                        <div className="form-group d-flex">
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="isDisplay" name="isDisplay" value={formData.isDisplay} onChange={handleChange} />
                            </div>
                            <label htmlFor="exampleFormControlInput1">isDisplay</label>
                        </div>
                        <div className="form-group d-flex">
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="isActive" name="isActive" value={formData.isActive} onChange={handleChange} />
                            </div>
                            <label htmlFor="exampleFormControlInput1">isActive</label>
                        </div>
                        <div className="d-flex form-buttons" style={{ gap: "15px" }}>
                            <div className="submit-btn pt-2">
                                <button type="submit">{productId ? 'Update' : 'Submit'}</button>
                            </div>
                            <div className="reset-btn pt-2">
                                <button className="" onClick={handleReset}>Reset</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </Layout>
    )
}

export default ProductDetailById;